module.exports = __webpack_public_path__ + "img/0Q3B8639-42_H_BlackMatted_MockedUp.9a1988f9.jpg";